import React from 'react'
import '../ComponentStyles/Homebar.css'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'

const Homebar = () => {
  return (
    <div className='homebar-main-container'>
      <Container style={{display: "flex", alignItems: "center"}}>
        <strong className='homebar-title'>JJS Consultancy</strong>
      </Container>  
      <Container style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}> 
          <span style={{color: "whitesmoke", marginLeft: "1vw", marginRight: "1vw"}}>Home</span>
          <span style={{color: "whitesmoke", marginLeft: "1vw", marginRight: "1vw"}}>About</span>
          <NavDropdown style={{color: "whitesmoke", marginLeft: "1vw", marginRight: "1vw"}} title="Services">
            <NavDropdown.Item href="#services/1">Business Solutions</NavDropdown.Item>
            <NavDropdown.Item href="#services/2">Software & Development</NavDropdown.Item>
            <NavDropdown.Item href="#services/3">Facilities & Compliance</NavDropdown.Item>
            <NavDropdown.Item href="#services/4">Training & Support</NavDropdown.Item>
          </NavDropdown>
      </Container>
    </div>
  )
}

export default Homebar